import { api } from '../../../../redux/setupAxios';
import { dateToTimestamp } from '../../../helper';

const FEED_URL = 'feed';

export const getFunFacts = async ({ from, to, merchantId }) => {
    from = dateToTimestamp(from, 0);
    to = dateToTimestamp(to, Date.now());
    try {
        const { data } = await api.get(`${FEED_URL}/fun-facts`, {
            params: {
                fromTs: from,
                toTs: to,
                merchantId
            },
        });
        return data;
    } catch (err) {
        return [];
    }
};